import { render, staticRenderFns } from "./MapProductsModal.vue?vue&type=template&id=c2468d84&scoped=true&"
import script from "./MapProductsModal.vue?vue&type=script&lang=js&"
export * from "./MapProductsModal.vue?vue&type=script&lang=js&"
import style0 from "./MapProductsModal.vue?vue&type=style&index=0&id=c2468d84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2468d84",
  null
  
)

export default component.exports